module.exports = __webpack_public_path__ + "static/media/loader.f1ab3eaf.svg";